<template>
  <div class="fm2-container">
    <div class="fm2-main flex">
      <div class="w-250px">
        <div class="components-list">
          <template v-if="basicFields.length">
            <div class="widget-cate">{{ $t('fm.components.basic.title') }}</div>
            <draggable
              :list="basicComponents"
              :move="handleMove"
              @end="handleMoveEnd"
              @start="handleMoveStart"
              tag="ul"
              v-bind="{group:{ name:'people', pull:'clone',put:false},sort:false, ghostClass: 'ghost'}"
            >
              <template v-for="(item, index) in basicComponents">
                <li
                  :class="{'no-put': item.type == 'divider'}"
                  :key="index"
                  class="form-edit-widget-label"
                  v-if="basicFields.indexOf(item.type)>=0"
                >
                  <a>
                    <i :class="item.icon" class="icon iconfont" />
                    <span>{{ item.name }}</span>
                  </a>
                </li>
              </template>
            </draggable>
          </template>

          <template v-if="advanceFields.length">
            <div class="widget-cate">{{ $t('fm.components.advance.title') }}</div>
            <draggable
              :list="advanceComponents"
              :move="handleMove"
              @end="handleMoveEnd"
              @start="handleMoveStart"
              tag="ul"
              v-bind="{group:{ name:'people', pull:'clone',put:false},sort:false, ghostClass: 'ghost'}"
            >
              <template v-for="(item, index) in advanceComponents">
                <li
                  :class="{'no-put': item.type == 'table'}"
                  :key="index"
                  class="form-edit-widget-label"
                  v-if="advanceFields.indexOf(item.type) >= 0"
                >
                  <a>
                    <i :class="item.icon" class="icon iconfont" />
                    <span>{{ item.name }}</span>
                  </a>
                </li>
              </template>
            </draggable>
          </template>

          <template v-if="layoutFields.length">
            <div class="widget-cate">{{ $t('fm.components.layout.title') }}</div>
            <draggable
              :list="layoutComponents"
              :move="handleMove"
              @end="handleMoveEnd"
              @start="handleMoveStart"
              tag="ul"
              v-bind="{group:{ name:'people', pull:'clone',put:false},sort:false, ghostClass: 'ghost'}"
            >
              <template v-for="(item, index) in layoutComponents">
                <li :key="index" class="form-edit-widget-label no-put" v-if="layoutFields.indexOf(item.type) >=0">
                  <a>
                    <i :class="item.icon" class="icon iconfont" />
                    <span>{{ item.name }}</span>
                  </a>
                </li>
              </template>
            </draggable>
          </template>
        </div>
      </div>
      <div class="center-container flex-1 flex flex-col h-575px">
        <div class="btn-bar" style="height: 45px;">
          <a-button @click="handleUpload" type="link" v-if="upload">{{ $t('fm.actions.import') }}</a-button>
          <a-button @click="handleClear" type="link" v-if="clearable">{{ $t('fm.actions.clear') }}</a-button>
          <a-button @click="handlePreview" type="link" v-if="preview">{{ $t('fm.actions.preview') }}</a-button>
          <a-button @click="handleGenerateJson" type="link" v-if="generateJson">{{ $t('fm.actions.json') }}</a-button>
          <a-button @click="handleGenerateCode" type="link" v-if="generateCode">{{ $t('fm.actions.code') }}</a-button>
        </div>
        <div :class="{'widget-empty': widgetForm.list.length == 0}" class="el-main relative">
          <widget-form :data="widgetForm" :select.sync="widgetFormSelect" ref="widgetForm" v-if="!resetJson" />
        </div>
      </div>

      <div class="widget-config-container" style="width: 305px;">
        <div height="45px">
          <div
            :class="{active: configTab=='widget'}"
            @click="handleConfigSelect('widget')"
            class="config-tab"
          >{{ $t('fm.config.widget.title') }}</div>
          <div
            :class="{active: configTab=='form'}"
            @click="handleConfigSelect('form')"
            class="config-tab"
          >{{ $t('fm.config.form.title') }}</div>
        </div>
        <div class="config-content h-575px">
          <widget-config :data="widgetFormSelect" v-if="widgetFormSelect!==null" v-show="configTab=='widget'" />
          <form-config :data="widgetForm.config" v-show="configTab=='form'" />
        </div>
      </div>

      <cus-dialog :visible="previewVisible" @on-close="previewVisible = false" form ref="widgetPreview" width="1000px">
        <generate-form
          :data="widgetForm"
          :remote="remoteFuncs"
          :value="widgetModels"
          @on-change="handleDataChange"
          insite="true"
          ref="generateForm"
          v-if="previewVisible"
        >
          <template slot-scope="scope">
            Width
            <a-input style="width: 100px" v-model="scope.model.blank.width" />Height
            <a-input style="width: 100px" v-model="scope.model.blank.height" />
          </template>
        </generate-form>

        <template slot="action">
          <a-button @click="handleTest" type="primary">{{ $t('fm.actions.getData') }}</a-button>
          <a-button @click="handleReset">{{ $t('fm.actions.reset') }}</a-button>
        </template>
      </cus-dialog>

      <cus-dialog
        :visible="uploadVisible"
        @on-close="uploadVisible = false"
        @on-submit="handleUploadJson"
        form
        ref="uploadJson"
        width="800px"
      >
        <a-alert :title="$t('fm.description.uploadJsonInfo')" type="info" />
        <div id="uploadeditor" style="height: 400px;width: 100%;">{{ jsonEg }}</div>
      </cus-dialog>

      <cus-dialog :visible="jsonVisible" @on-close="jsonVisible = false" form ref="jsonPreview" width="800px">
        <div id="jsoneditor" style="height: 400px;width: 100%;">{{ jsonTemplate }}</div>

        <template slot="action">
          <a-button :data-clipboard-text="jsonCopyValue" class="json-btn" type="primary">{{ $t('fm.actions.copyData') }}</a-button>
        </template>
      </cus-dialog>

      <cus-dialog
        :action="false"
        :visible="codeVisible"
        @on-close="codeVisible = false"
        form
        ref="codePreview"
        width="800px"
      >
        <div id="codeeditor" style="height: 500px; width: 100%;">{{ htmlTemplate }}</div>
      </cus-dialog>
    </div>

    <!-- <a-footer height="30px" style="font-weight: 600;">Powered by <a target="_blank" href="http://www.fdevops.com">fdevops</a></a-footer> -->
  </div>
</template>

<script>
  import Draggable from 'vuedraggable'
  import WidgetConfig from './WidgetConfig'
  import FormConfig from './FormConfig'
  import WidgetForm from './WidgetForm'
  import CusDialog from './CusDialog'
  import GenerateForm from './GenerateForm'
  import Clipboard from 'clipboard'
  import { basicComponents, layoutComponents, advanceComponents } from './componentsConfig.js'
  import request from '../util/request.js'
  import generateCode from './generateCode.js'

  var ace = require('ace-builds/src-noconflict/ace')
  ace.config.set('basePath', '/lib/ace')
  ace.config.set('modePath', '/lib/ace')
  ace.config.set('themePath', '/lib/ace')
  window.define = window.define || ace.define
  window.require = window.require || ace.require

  export default {
    name: 'FmMakingForm',
    components: {
      Draggable,
      WidgetConfig,
      FormConfig,
      WidgetForm,
      CusDialog,
      GenerateForm
    },
    props: {
      preview: {
        type: Boolean,
        default: false
      },
      generateCode: {
        type: Boolean,
        default: false
      },
      generateJson: {
        type: Boolean,
        default: false
      },
      upload: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      basicFields: {
        type: Array,
        default: () => ['input', 'textarea', 'number', 'radio', 'checkbox', 'time', 'date', 'rate', 'color', 'select', 'switch', 'slider', 'text']
      },
      advanceFields: {
        type: Array,
        default: () => ['blank', 'imgupload', 'editor', 'cascader']
      },
      layoutFields: {
        type: Array,
        default: () => ['grid', 'divider']
      }
    },
    data () {
      return {
        basicComponents,
        layoutComponents,
        advanceComponents,
        resetJson: false,
        widgetForm: {
          list: [],
          config: {
            labelWidth: 100,
            labelPosition: 'right',
            size: 'small'
          }
        },
        configTab: 'widget',
        widgetFormSelect: null,
        previewVisible: false,
        jsonVisible: false,
        codeVisible: false,
        uploadVisible: false,
        remoteFuncs: {
          func_test (resolve) {
            setTimeout(() => {
              const options = [
                { id: '1', name: '1111' },
                { id: '2', name: '2222' },
                { id: '3', name: '3333' }
              ]

              resolve(options)
            }, 2000)
          },
          funcGetToken (resolve) {
            request.get('http://tools-server.xiaoyaoji.cn/api/uptoken').then(res => {
              resolve(res.uptoken)
            })
          },
          upload_callback (response, file, fileList) {
          }
        },
        widgetModels: {},
        blank: '',
        htmlTemplate: '',
        jsonTemplate: '',
        uploadEditor: null,
        jsonCopyValue: '',
        jsonClipboard: null,
        jsonEg: `{
  "list": [],
  "config": {
    "labelWidth": 100,
    "labelPosition": "top",
    "size": "small"
  }
}`
      }
    },
    watch: {
      widgetForm: {
        deep: true,
        handler: function (val) {
        }
      },
      '$lang': function (val) {
        this._loadComponents()
      }
    },
    mounted () {
      this._loadComponents()
    },
    methods: {
      _loadComponents () {

        this.basicComponents = this.basicComponents.map(item => {
          return {
            ...item,
            name: this.$t(`fm.components.fields.${item.type}`)
          }
        })
        this.advanceComponents = this.advanceComponents.map(item => {
          return {
            ...item,
            name: this.$t(`fm.components.fields.${item.type}`)
          }
        })
        this.layoutComponents = this.layoutComponents.map(item => {
          return {
            ...item,
            name: this.$t(`fm.components.fields.${item.type}`)
          }
        })
      },
      handleConfigSelect (value) {
        this.configTab = value
      },
      handleMoveEnd (evt) {
      },
      handleMoveStart ({ oldIndex }) {
      },
      handleMove () {
        return true
      },
      handlePreview () {
        this.previewVisible = true
      },
      handleTest () {
        this.$refs.generateForm.getData().then(data => {
          this.$alert(data, '').catch(e => { })
          this.$refs.widgetPreview.end()
        }).catch(e => {
          this.$refs.widgetPreview.end()
        })
      },
      handleReset () {
        this.$refs.generateForm.reset()
      },
      handleGenerateJson () {
        this.jsonVisible = true
        this.jsonTemplate = this.widgetForm
        this.$nextTick(() => {
          const editor = ace.edit('jsoneditor')
          editor.session.setMode('ace/mode/json')

          if (!this.jsonClipboard) {
            this.jsonClipboard = new Clipboard('.json-btn')
            this.jsonClipboard.on('success', (e) => {
              this.$message.success(this.$t('fm.message.copySuccess'))
            })
          }
          this.jsonCopyValue = JSON.stringify(this.widgetForm)
        })
      },
      handleGenerateCode () {
        this.codeVisible = true
        this.htmlTemplate = generateCode(JSON.stringify(this.widgetForm))
        this.$nextTick(() => {
          const editor = ace.edit('codeeditor')
          editor.session.setMode('ace/mode/html')
        })
      },
      handleUpload () {
        this.uploadVisible = true
        this.$nextTick(() => {
          this.uploadEditor = ace.edit('uploadeditor')
          this.uploadEditor.session.setMode('ace/mode/json')
        })
      },
      handleUploadJson () {
        try {
          this.setJSON(JSON.parse(this.uploadEditor.getValue()))
          this.uploadVisible = false
        } catch (e) {
          this.$message.error(e.message)
          this.$refs.uploadJson.end()
        }
      },
      handleClear () {
        this.widgetForm = {
          list: [],
          config: {
            labelWidth: 100,
            labelPosition: 'right',
            size: 'small',
            customClass: ''
          }
        }

        this.widgetFormSelect = {}
      },
      getJSON () {
        return this.widgetForm
      },
      getHtml () {
        return generateCode(JSON.stringify(this.widgetForm))
      },
      setJSON (json) {
        this.widgetForm = json

        if (json.list.length > 0) {
          this.widgetFormSelect = json.list[0]
        }
      },
      handleInput (val) {
        this.blank = val
      },
      handleDataChange (field, value, data) {
      }
    }
  }
</script>

<style lang="less">
  .widget-empty {
    background-position: 50%;
  }
  .el-main {
    display: block;
    flex: 1;
    flex-basis: auto;
    overflow: auto;
    padding: 0;
    box-sizing: border-box;
  }

  aside {
    background: #ffffff;
    padding: 0;
    margin-bottom: 0;

    a {
      color: #333333;
    }
  }
  .config-content {
    overflow-y: scroll;
  }
</style>
